export const EV_COMPANY_TYPE = 'ev' as const
export const NON_EV_COMPANY_TYPE = 'non-ev' as const

export const COMMUNICATION_MODE_INTERCOM = 'intercom' as const
export const COMMUNICATION_MODE_HUBSPOT = 'hubspot' as const
